module.exports = __webpack_public_path__ + "img/video-icon.2feb41fb.png";